// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"406b58f6","41":"f70b7193","51":"8c96524b","53":"bd91e195","127":"37ebc738","544":"01b677a4","558":"79ebc170","624":"0ac32f70","756":"614d8a01","867":"1059b818","915":"8210e805"}[chunkId] + ".chunk.js";
};